import React, { useCallback, useMemo, useState } from "react";
import { classnames, ClickClose, Icon } from "@culturehq/components";
import { t } from "app/utils";

const QuickOptions = ({ children, className, sticky, theme, withSubdropdown }) => {
  const [open, setOpen] = useState(false);

  const onClose = useCallback(() => setOpen(false), [setOpen]);
  const onToggle = useCallback(() => setOpen(current => !current), [setOpen]);

  const classList = useMemo(
    () => classnames(
      "QuickOptions",
      className,
      theme || "white",
      open ? "active" : "inactive",
      { sticky }
    ),
    [className, open, sticky, theme]
  );

  const handleClose = () => {
    if (!withSubdropdown) {
      onClose();
    }
  };

  return (
    <ClickClose className={classList} onClose={onClose}>
      <button
        type="button"
        className="QuickOptions__open-dropdown clickable transparent-button"
        onClick={event => {
          event.stopPropagation();
          onToggle();
        }}
        aria-label={t("Item options")}
        tabIndex={-1}
        aria-hidden
      >
        <div className="QuickOptions__open-dropdown__wrapper">
          <Icon icon={open ? "close" : "more"} />
        </div>
      </button>
      <div className="QuickOptions__menu-wrapper" onClick={handleClose}>
        <div className="QuickOptions__menu box-shadow">
          {children}
        </div>
      </div>
    </ClickClose>
  );
};

export default QuickOptions;
